<template>
  <a
    v-if="unverifiedUser && isCurrentUser && !isLoggedOut"
    @click.prevent="goToLink"
    class="cursor-pointer"
  >
    <div class="flex flex-row items-center w-full mb-4 md:mb-5">
      <div class="rounded-tl rounded-bl bg-red-300 block self-stretch flex items-center">
        <i class="block sr-2 sr-v2-non-verified-badge text-base text-white px-2"></i>
      </div>
      <div class="ds-text-xs w-full">
        <p class="p-2 text-red-300 bg-red-100 font-normal rounded-tr rounded-br">
          <span class="font-semibold">Your profile is not verified for college coaches.</span>
          <span class="underline text-red-300">
            Complete verification now
            <i class="sr-2 sr-v2-arrow-right text-red-300 font-normal"></i>
          </span>
        </p>
      </div>
    </div>
    
    <HelpModal :show="showModal" @close="showModal = false" />
  </a>
</template>

<script>
import track from "@/utils/segment";
import HelpModal from '../Verification/HelpModal';
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    HelpModal,
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    ...mapState({
      isVerified: state => state.athleteProfile.user.isVerified
    }),
    ...mapGetters({
      isLoggedOut: "userData/isLoggedOut",
      isPlayer: "userData/isPlayer",
      isFree: "userData/isFree",
      isPaid: "userData/isPaid",
      isExpired: "userData/isExpired",
      isIdentityVerified: "userData/isIdentityVerified",
      isCurrentUser: "athleteProfile/isCurrentUser"
    }),
    unverifiedUser() {
      return this.isPlayer && (!this.isVerified || (this.isIdentityVerificationEnabled && !this.isIdentityVerified));
    },
    isIdentityVerificationEnabled() {
      return this.$domain.config('identity_verification.steps.complete_verification_call.enabled');
    },
    verificationCTALink() {
      if (this.isFree && !this.isIdentityVerified) return "/account/schedule";
      else if (this.isPaid || this.isExpired || this.isIdentityVerified)
        return "/athlete_profile";
    }
  },
  methods: {
    goToLink() {
      if (this.isPlayer) {
        const eventName =
          (this.unverifiedUser && this.isExpired && "expired_cta") ||
          (this.unverifiedUser &&
            this.isPaid &&
            !this.isExpired &&
            "get_verified_cta_paid_user") ||
          (this.unverifiedUser &&
            this.isFree &&
            this.isIdentityVerified &&
            "upgrade_account_cta") ||
          (this.unverifiedUser && this.isFree && "get_verified_cta");

        track(eventName, {
          cta_page: "profile",
          cta_name: "profile_banner"
        });
      }
      if (this.$domain.config('identity_verification.cta.modal')) {
        this.showModal = true;
      } else {
        window.location.href = this.verificationCTALink;
      }
    }
  }
};
</script>